import MemberVacancies from './MemberVacancies.component';

export default MemberVacancies;
